import React, { useRef, useEffect, useState } from 'react';
import Drawer from 'components/drawer';
import Button from 'components/button';
import Input from 'components/input';
import { Pos } from 'assets/svgs';
import Counter from 'components/Counter';
import classname from 'classname';
import { globalStyles } from 'styles';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import styles from './modals.module.scss';
import { activateTerminal } from '../../../../store/actions/terminal';

const Activate = ({
  drawerActive,
  onClose,
  setShowActivate,
  setSuccess,
  setError,
  data,
}) => {
  const [serialNumber, setSerialNumber] = React.useState('');
  const [terminalID, setTerminalID] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const dispatch = useDispatch();

  const onSuccess = () => {
    setSuccess(true);
    setLoading(false);
    setShowActivate(false);
  };

  const onFailure = (e) => {
    toast.error(e);
    setError(e);
    setLoading(false);
    setShowActivate(false);
  };

  const activateTerminalRequest = (param) => {
    dispatch(activateTerminal(param, onSuccess, onFailure));
  };

  const handleActivation = () => {
    setLoading(true);
    const params = {
      ...(data?.id && { requestId: data.id }),
      ...(terminalID && { terminalId: terminalID }),
      ...(serialNumber && { serialNumber }),
    };

    activateTerminalRequest(params);
  };

  return (
    <Drawer
      title="Activating your terminal"
      setDrawerActive={onClose}
      drawerActive={drawerActive}
    >
      <Drawer.DrawerBody>
        <h5 className={styles.activateHeading}>
          Check the back of your terminal for your serial number. An example
          image is shown below.
        </h5>
        <Pos />
        <p className={styles.activateSubHeading}>
          Enter the terminal ID or serial number in the field below so we
          can activate your terminal and get it ready for use.
        </p>
        <div
          className={classname(
            styles.activateSubHeading,
            globalStyles.flex,
            globalStyles.justifyContentBetween,
            globalStyles.alignItemsCenter,
          )}
        >
          <Input
            label="Terminal ID"
            variant="blue"
            name="terminalID"
            value={terminalID}
            onChange={(e) => setTerminalID(e.target.value)}
          />
          <Input
            label="Serial Number"
            variant="blue"
            name="serialNumber"
            value={serialNumber}
            onChange={(e) => setSerialNumber(e.target.value)}
          />
        </div>
        <Button
          text="Activate Terminal"
          variant="primary"
          style={{ height: '50px' }}
          onClick={handleActivation}
          loading={loading}
          loadingtext="Please wait..."
        />
      </Drawer.DrawerBody>
    </Drawer>
  );
};

export default Activate;
